var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-file-list flex-wrap",class:[`s-${_vm.size}`],on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.list),function(image,i){return _c('c-file',{key:i,attrs:{"src":image,"media":_vm.media,"preview":_vm.list}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }